import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { RootStore } from "../../../../redux/store"
import { settingsService } from "../../../../services/settingsService"

const useAbsenceEmployee = (employeeId?: number) => {

  const { allEmployees } = useSelector((state: RootStore) => state.appSettings)

  const [selectedEmployee, setSelectedEmployee] = useState(
    allEmployees.find(e => e.employeeId === employeeId)
  )

  const [departmentWorksWeekends, setDepartmentWorksWeekends] = useState<boolean>(false)

  useEffect(() => {
    if (!selectedEmployee) {
      return
    }

    settingsService.getSettings(selectedEmployee.departmentId).then(res => {
      setDepartmentWorksWeekends(res.areWeekendsWorked)
    })
  }, [selectedEmployee])

  return {
    selectedEmployee,
    setSelectedEmployee,
    departmentWorksWeekends
  }
}

export default useAbsenceEmployee